export default __webpack_public_path__ + "static/media/1010-west-lamp.dce7bb48.jpg";